<template>
    <div class="transaksi-card">
        <div v-for="(data, idx) in dataList" :key="`${idx}-card-transaksi`" class="items" @click="toggleTransaksi(data.idtransaksi)">
            <SOCheckBox :is-checked="isCheckedItem(data.idtransaksi)" />
            <SOSlotCard
                :id="`transaksi-${data.idtransaksi}`"
                :last-id="getLastId"
                :card-type="typeCard"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
            >
                <template v-slot:card_head>
                    <div class="">
                        <div class="">
                            <span>{{ data.idtransaksi }}</span>
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div class="c-body">
                        <p class="m-d-0 f-13">
                            <span>
                                Transaksi {{ $moment(data.created_at).format("Do MMM YYYY") }} oleh
                                {{ data.nama }}
                            </span>
                        </p>
                        <p class="m-d-0 f-13">
                            <span>Di outlet </span><span class="f-bold">{{ data.nama_outlet }}</span>
                        </p>
                        <p class="m-d-0 f-14 f-semi">
                            <span class="f-c-blue">Rp {{ data.grandtotal | decimal }}</span>
                            <span> • </span>
                            <span class="f-regular">{{ data.status }}</span>
                        </p>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";

import { moduleName } from "../store/state";

export default {
    name: "CardTransaksi",
    props: {
        typeCard: {
            type: String,
            default: "none",
        },
        dataList: {
            type: Array,
            default: function() {
                return [];
            },
        },
        loadData: {
            type: Function,
            required: true,
        },
    },
    components: {
        SOSlotCard,
        SOCheckBox,
    },
    computed: {
        ...mapGetters(moduleName, {
            transaksiEnd: "transaksiEnd",
            transaksiTotal: "transaksiTotal",
            transaksiPage: "transaksiPage",
            transaksiList: "transaksiList",
            isLoadMore: "isLoadMore",
            selectedTransaksi: "selectedTransaksi",
            checkAllItem: "checkAllItem",
        }),
        getLastId() {
            return this.transaksiEnd.idtransaksi ? `transaksi-${this.transaksiEnd.idtransaksi}` : "";
        },
        isCheckedItem() {
            return (id) => {
                let exist = this.selectedTransaksi.find(transaksi => transaksi === id);

                let isChecked = exist === undefined ? false : true;

                if (isChecked === false) {
                    // isChecked = this.checkAllItem.find(transaksi => transaksi === id) === undefined ? false : true;
                }

                return isChecked;
            }
        }
    },
    methods: {
        ...mapActions({
            toggleTransaksiShow: `${moduleName}/toggleTransaksiShow`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleSelectedTransaksi: `${moduleName}/toggleSelectedTransaksi`,
        }),
        async doLoadMore() {
            if (this.transaksiTotal > this.transaksiPage.length) {
                if (!this.isLoadMore) {
                    await this.setLoadMore(true);
                    await this.loadData();
                }
            }
        },
        toggleTransaksi(id) {
            this.toggleSelectedTransaksi(id)
        },
        toggleCard(data) {
            this.toggleTransaksiShow(data);
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
